export const PolymediaLogo: React.FC = () => {
	const logoUrl = "https://assets.polymedia.app/img/all/logo-nomargin-transparent-512x512.webp";
	return <img alt="Polymedia" height="33" width="33" src={logoUrl} />;
};
